module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAQhJREFUOBG1lDEOwjAMReMO5RKM3IeRDQZgQmLjFEgMrMDAvRi5RDtgeC2p0tI6LQIPTZT8/+LIqZ17x+qoYz8fOobeBPP8kE3zPL8t9vlyKAwPXhh4BToLqjpyIpqorK+79NIHDOwhenKq8oosTdNJct7KXVQ2wNhA0CfTEIYXRsHymTQFVqaWVjyQ0RJ6XUxTA8agMRj+D2AXlHVfAKt4rcA2KGsUzYIh6QSyWbtioY4/q+Jho/1VdGZYy443Snx75SaMNwnvq6K0wfyvaO1xIFG7ch9DTFMBY8Ly/PJraQugJQhB4bzL85/25RI3o59ZHSbMzs8pFh68MGhffs+Fbbxa7DkJvU/knUtUcIAtowAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/close_icon_blue_10_10@2x.png
// module id = ./src/_asset/sources/assets/images/close_icon_blue_10_10@2x.png
// module chunks = main